import { render, staticRenderFns } from "./HomePage.vue?vue&type=template&id=67a1c8a4&scoped=true&"
import script from "./HomePage.vue?vue&type=script&lang=js&"
export * from "./HomePage.vue?vue&type=script&lang=js&"
import style0 from "./HomePage.vue?vue&type=style&index=0&id=67a1c8a4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a1c8a4",
  null
  
)

export default component.exports